module.exports = __webpack_public_path__ + "static/media/email.d9e13808.png";